export default __webpack_public_path__ + "images/65134ef385de13903557ed8069b2a8f6.png";